// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multimedia-hub {
  --mh-primary: #0f6ea8;
  --mh-accent: #1ca3ec;
  --mh-ink: #14324a;
  --mh-muted: #6f8597;
  --mh-surface: #ffffff;
  --mh-bg: linear-gradient(135deg, #f4f8fc 0%, #ecf3fb 50%, #f9fbff 100%);
  --mh-border: #d8e6f5;
  --mh-shadow: 0 18px 40px rgba(15, 57, 95, 0.12);
  background: var(--mh-bg);
  border: 1px solid var(--mh-border);
  border-radius: 16px;
  padding: 16px;
  box-shadow: var(--mh-shadow);
}

.multimedia-hub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.multimedia-hub-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--mh-ink);
}

.multimedia-hub-subtitle {
  margin: 2px 0 0;
  font-size: 0.86rem;
  color: var(--mh-muted);
}

.multimedia-hub-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: var(--mh-primary);
  background: #eaf5ff;
  border: 1px solid #cfe7fb;
  border-radius: 999px;
  padding: 6px 10px;
}

.multimedia-hub-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
  width: 100%;
  min-width: 0;
}

.mh-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #9cc8eb;
  background: #fff;
  color: #165c8a;
  border-radius: 10px;
  padding: 7px 14px;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.2s ease;
  transform: translateY(0);
  min-width: 0;
  box-sizing: border-box;
}

.mh-tab:hover {
  background: #f2f9ff;
  border-color: #7fb4df;
  transform: translateY(-1px);
}

.mh-tab.is-active {
  background: linear-gradient(135deg, var(--mh-primary), var(--mh-accent));
  color: #fff;
  border-color: transparent;
  box-shadow: 0 10px 24px rgba(24, 119, 179, 0.28);
}

.mh-tab i {
  font-size: 1rem;
}

.multimedia-hub-links {
  margin-bottom: 14px;
  font-size: 0.95rem;
  overflow-wrap: anywhere;
}

.multimedia-hub-links a {
  color: #1f6ea5;
  text-decoration: none;
  font-weight: 600;
}

.multimedia-hub-links a:hover {
  text-decoration: underline;
}

.multimedia-hub-content {
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #dbe8f6;
  border-radius: 14px;
  padding: 12px;
  animation: mh-fade-in 0.28s ease;
  overflow: hidden;
}

.multimedia-hub-content .row {
  --bs-gutter-x: 14px;
  --bs-gutter-y: 10px;
}

.multimedia-hub-content .row > [class*="col-"] {
  padding-left: calc(var(--bs-gutter-x) * 0.5) !important;
  padding-right: calc(var(--bs-gutter-x) * 0.5) !important;
}

.multimedia-hub-gallery-shell {
  width: 100%;
  min-height: 100%;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.multimedia-hub #prueba,
.multimedia-hub #panelinfo {
  height: 100%;
}

@media (min-width: 992px) {
  .multimedia-hub .row > .col-md-6:first-child {
    flex: 0 0 54%;
    max-width: 54%;
  }

  .multimedia-hub .row > .col-md-6:last-child {
    flex: 0 0 46%;
    max-width: 46%;
  }
}

.multimedia-hub .carousel-root {
  border-radius: 12px;
  overflow: hidden;
  margin: 0;
}

.multimedia-hub #prueba {
  background: #0c1a24;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 8px;
}

.multimedia-hub .carousel .slider-wrapper {
  margin: 0;
}

.multimedia-hub .thumbs-wrapper {
  margin: 8px 0 0;
}

.multimedia-hub #panelinfo > div:first-child,
.multimedia-hub .attribute_class .container_span_iconName,
.multimedia-hub .accordion-button,
.multimedia-hub .color_name_attribute {
  background: linear-gradient(135deg, #0a5a8a, #1178b8) !important;
}

.multimedia-hub #infofoto,
.multimedia-hub #infojson,
.multimedia-hub #infofoto2 {
  border: 1px solid #d0e2f4 !important;
  border-radius: 10px;
  background: #fcfeff;
}

.multimedia-hub #infojson,
.multimedia-hub #infofoto2 {
  height: 320px !important;
}

.multimedia-hub .mh-panel-shell {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.multimedia-hub .mh-panel-title,
.multimedia-hub .mh-analytics-header {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 12px;
  border-radius: 12px 12px 0 0;
  background: linear-gradient(135deg, #0a5a8a, #1178b8);
  border: 1px solid #0b6ca6;
  border-bottom: 0;
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 6px 14px rgba(9, 62, 95, 0.08);
}

.multimedia-hub .mh-analytics-header-tools {
  position: relative;
  justify-content: center;
  gap: 8px;
  padding-right: 86px;
}

.multimedia-hub .mh-analytics-title {
  display: block;
  width: 100%;
  max-width: calc(100% - 96px);
  text-align: center;
  color: #ffffff;
  font-weight: 700;
  padding: 0 8px;
}

.multimedia-hub .mh-analytics-actions {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.multimedia-hub .mh-analytics-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  padding: 0;
  cursor: pointer;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 3px 8px rgba(3, 40, 66, 0.18);
  transition: transform 0.18s ease, background 0.18s ease, border-color 0.18s ease;
}

.multimedia-hub .mh-analytics-action-btn:hover {
  background: rgba(255, 255, 255, 0.24);
  border-color: rgba(255, 255, 255, 0.72);
  transform: scale(1.05);
}

.multimedia-hub .mh-analytics-icon {
  width: 18px;
  cursor: pointer;
  color: #ffffff;
  filter: brightness(0) invert(1) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.22));
  opacity: 1;
}

.multimedia-hub .mh-analytics-action-btn i.mh-analytics-icon {
  width: auto;
  font-size: 18px !important;
  line-height: 1;
}

.multimedia-hub .mh-info-card,
.multimedia-hub .mh-analytics-body {
  border: 1px solid #d0e2f4 !important;
  border-radius: 0 0 12px 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fcff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.multimedia-hub .mh-info-card {
  padding: 10px 14px !important;
  line-height: 1.35;
}

.multimedia-hub .mh-analytics-shell .row {
  align-items: stretch;
}

.multimedia-hub .mh-analytics-body {
  border-top: 0 !important;
  padding: 8px !important;
}

.multimedia-hub .mh-analytics-shell .col-md-6 {
  display: flex;
  flex-direction: column;
}

.multimedia-hub #infojson .accordion-item {
  border: 1px solid #dce8f6;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 6px 16px rgba(14, 71, 111, 0.06);
  margin-bottom: 8px;
}

.multimedia-hub #infojson .accordion-button {
  color: #fff !important;
  border: 0;
  box-shadow: none !important;
  font-weight: 700;
  padding: 8px 10px;
}

.multimedia-hub #infojson .accordion-button:not(.collapsed) {
  color: #fff !important;
}

.multimedia-hub #infojson .accordion-body {
  padding: 8px 10px;
  background: #f8fbff;
}

.multimedia-hub #infojson ul,
.multimedia-hub #infofoto2 ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.multimedia-hub .attribute_class {
  margin-bottom: 8px;
  border: 1px solid #deebf7;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.multimedia-hub .attribute_class .container_span_iconName {
  display: block;
  padding: 6px 10px;
  color: #fff;
  font-weight: 700;
}

.multimedia-hub .attribute_content,
.multimedia-hub .content_content,
.multimedia-hub .word_content {
  display: block;
  padding: 8px 10px;
  border-top: 1px solid #edf3fa;
  color: #183d59;
  font-weight: 600;
  background: #fff;
}

.multimedia-hub .content_content,
.multimedia-hub .word_content {
  cursor: pointer;
}

.multimedia-hub .content_content:hover,
.multimedia-hub .word_content:hover {
  background: #eef7ff;
}

.multimedia-hub .object-box,
.multimedia-hub .object-box2,
.multimedia-hub .object-box3 {
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.25), 0 8px 20px rgba(12, 92, 144, 0.18);
}

.multimedia-hub .mh-status-banner {
  margin-top: 8px;
  border-radius: 10px;
  padding: 8px 12px;
  color: #fff;
  text-align: center;
  font-weight: 700;
  box-shadow: 0 10px 22px rgba(23, 52, 76, 0.14);
}

.multimedia-hub .mh-status-banner.is-success {
  background: linear-gradient(135deg, #118a3f, #27b35d);
}

.multimedia-hub .mh-status-banner.is-danger {
  background: linear-gradient(135deg, #c62828, #eb5757);
}

.multimedia-hub .thumbs .thumb.selected,
.multimedia-hub .thumbs .thumb:hover {
  border-color: #1283c2;
}

.multimedia-hub-actions-card {
  border: 1px solid #dbe8f5;
  border-radius: 12px;
  padding: 14px;
  background: #fff;
}

.multimedia-hub-actions-card h6 {
  color: #1a4d75;
  font-weight: 700;
  text-align: center;
}

.multimedia-hub-actions-card p {
  color: #6a8091;
  text-align: center;
}

.multimedia-hub-actions-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.multimedia-hub-actions-col {
  flex: 1 1 320px;
  min-width: 280px;
}

.multimedia-hub-action-icon {
  width: 72px;
  height: 72px;
  margin: 2px auto 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f6ea8;
  background: linear-gradient(135deg, #eaf5ff, #dff0ff);
  border: 1px solid #c8e2f8;
}

.multimedia-hub-action-icon i {
  font-size: 2rem;
}

.multimedia-hub-action-btn {
  width: 100%;
  justify-content: center;
  min-height: 42px;
}

.mh-skeleton-wrap {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 12px;
}

.mh-skeleton-media,
.mh-skeleton-panel {
  border-radius: 12px;
  border: 1px solid #dbe8f6;
  background: linear-gradient(110deg, #eef5fc 8%, #f7fbff 18%, #eef5fc 33%);
  background-size: 200% 100%;
  animation: mh-shimmer 1.3s linear infinite;
}

.mh-skeleton-media {
  min-height: 390px;
}

.mh-skeleton-panel {
  min-height: 390px;
}

.mh-empty-media {
  min-height: 390px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 12px;
  background: radial-gradient(circle at top, #183952 0%, #0e2234 46%, #081521 100%);
  color: #d8eeff;
  border: 1px solid #224e70;
}

.mh-empty-media i {
  font-size: 2.2rem;
  margin-bottom: 10px;
  color: #5dc3ff;
}

.mh-empty-media h4 {
  margin: 0;
  font-weight: 700;
}

.mh-empty-media p {
  margin-top: 8px;
  max-width: 320px;
  color: #a8d6f6;
}

@keyframes mh-shimmer {
  to {
    background-position-x: -200%;
  }
}

@keyframes mh-fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .multimedia-hub {
    padding: 8px;
    border-radius: 10px;
    margin: 0;
    width: 100%;
  }

  .multimedia-hub-header {
    gap: 8px;
    margin-bottom: 10px;
  }

  .multimedia-hub-title {
    font-size: 1rem;
  }

  .multimedia-hub-subtitle {
    font-size: 0.8rem;
    line-height: 1.2;
  }

  .multimedia-hub-chip {
    font-size: 0.72rem;
    padding: 4px 8px;
    max-width: 42%;
    line-height: 1.2;
  }

  .multimedia-hub-tabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
  }

  .mh-tab {
    width: 100%;
    justify-content: center;
    font-size: 0.84rem;
    padding: 8px 10px;
    min-height: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .multimedia-hub-links {
    margin: 10px 0 12px;
    font-size: 0.9rem;
    line-height: 1.35;
  }

  .multimedia-hub-content {
    padding: 8px;
    border-radius: 10px;
  }

  .multimedia-hub-content .row {
    --bs-gutter-x: 8px;
    --bs-gutter-y: 8px;
  }

  .multimedia-hub-actions-col {
    flex-basis: 100%;
    min-width: 0;
  }

  .multimedia-hub .en-vivo-panel {
    padding: 6px;
  }

  .multimedia-hub .en-vivo-layout {
    gap: 8px;
  }

  .multimedia-hub .en-vivo-card,
  .multimedia-hub .en-vivo-tracking {
    padding: 10px;
    border-radius: 10px;
  }

  .multimedia-hub .en-vivo-preview {
    margin-bottom: 8px;
  }

  .multimedia-hub #prueba {
    padding: 6px;
    margin-bottom: 6px;
  }

  .multimedia-hub #infofoto {
    margin-bottom: 6px;
  }

  .mh-skeleton-wrap {
    grid-template-columns: 1fr;
  }

  .mh-skeleton-media,
  .mh-skeleton-panel,
  .mh-empty-media {
    min-height: 240px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/multimediaHub.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,uEAAuE;EACvE,oBAAoB;EACpB,+CAA+C;EAC/C,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wEAAwE;EACxE,WAAW;EACX,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,gEAAgE;AAClE;;AAEA;;;EAGE,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,qDAAqD;EACrD,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,qFAAqF;AACvF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,UAAU;EACV,eAAe;EACf,mFAAmF;EACnF,gFAAgF;AAClF;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,0EAA0E;EAC1E,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,4BAA4B;EAC5B,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,mFAAmF;AACrF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,iFAAiF;EACjF,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,iBAAiB;EACnB;AACF","sourcesContent":[".multimedia-hub {\n  --mh-primary: #0f6ea8;\n  --mh-accent: #1ca3ec;\n  --mh-ink: #14324a;\n  --mh-muted: #6f8597;\n  --mh-surface: #ffffff;\n  --mh-bg: linear-gradient(135deg, #f4f8fc 0%, #ecf3fb 50%, #f9fbff 100%);\n  --mh-border: #d8e6f5;\n  --mh-shadow: 0 18px 40px rgba(15, 57, 95, 0.12);\n  background: var(--mh-bg);\n  border: 1px solid var(--mh-border);\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: var(--mh-shadow);\n}\n\n.multimedia-hub-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.multimedia-hub-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--mh-ink);\n}\n\n.multimedia-hub-subtitle {\n  margin: 2px 0 0;\n  font-size: 0.86rem;\n  color: var(--mh-muted);\n}\n\n.multimedia-hub-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  color: var(--mh-primary);\n  background: #eaf5ff;\n  border: 1px solid #cfe7fb;\n  border-radius: 999px;\n  padding: 6px 10px;\n}\n\n.multimedia-hub-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n  width: 100%;\n  min-width: 0;\n}\n\n.mh-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #9cc8eb;\n  background: #fff;\n  color: #165c8a;\n  border-radius: 10px;\n  padding: 7px 14px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  transform: translateY(0);\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.mh-tab:hover {\n  background: #f2f9ff;\n  border-color: #7fb4df;\n  transform: translateY(-1px);\n}\n\n.mh-tab.is-active {\n  background: linear-gradient(135deg, var(--mh-primary), var(--mh-accent));\n  color: #fff;\n  border-color: transparent;\n  box-shadow: 0 10px 24px rgba(24, 119, 179, 0.28);\n}\n\n.mh-tab i {\n  font-size: 1rem;\n}\n\n.multimedia-hub-links {\n  margin-bottom: 14px;\n  font-size: 0.95rem;\n  overflow-wrap: anywhere;\n}\n\n.multimedia-hub-links a {\n  color: #1f6ea5;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.multimedia-hub-links a:hover {\n  text-decoration: underline;\n}\n\n.multimedia-hub-content {\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px solid #dbe8f6;\n  border-radius: 14px;\n  padding: 12px;\n  animation: mh-fade-in 0.28s ease;\n  overflow: hidden;\n}\n\n.multimedia-hub-content .row {\n  --bs-gutter-x: 14px;\n  --bs-gutter-y: 10px;\n}\n\n.multimedia-hub-content .row > [class*=\"col-\"] {\n  padding-left: calc(var(--bs-gutter-x) * 0.5) !important;\n  padding-right: calc(var(--bs-gutter-x) * 0.5) !important;\n}\n\n.multimedia-hub-gallery-shell {\n  width: 100%;\n  min-height: 100%;\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n}\n\n.multimedia-hub #prueba,\n.multimedia-hub #panelinfo {\n  height: 100%;\n}\n\n@media (min-width: 992px) {\n  .multimedia-hub .row > .col-md-6:first-child {\n    flex: 0 0 54%;\n    max-width: 54%;\n  }\n\n  .multimedia-hub .row > .col-md-6:last-child {\n    flex: 0 0 46%;\n    max-width: 46%;\n  }\n}\n\n.multimedia-hub .carousel-root {\n  border-radius: 12px;\n  overflow: hidden;\n  margin: 0;\n}\n\n.multimedia-hub #prueba {\n  background: #0c1a24;\n  border-radius: 12px;\n  padding: 8px;\n  margin-bottom: 8px;\n}\n\n.multimedia-hub .carousel .slider-wrapper {\n  margin: 0;\n}\n\n.multimedia-hub .thumbs-wrapper {\n  margin: 8px 0 0;\n}\n\n.multimedia-hub #panelinfo > div:first-child,\n.multimedia-hub .attribute_class .container_span_iconName,\n.multimedia-hub .accordion-button,\n.multimedia-hub .color_name_attribute {\n  background: linear-gradient(135deg, #0a5a8a, #1178b8) !important;\n}\n\n.multimedia-hub #infofoto,\n.multimedia-hub #infojson,\n.multimedia-hub #infofoto2 {\n  border: 1px solid #d0e2f4 !important;\n  border-radius: 10px;\n  background: #fcfeff;\n}\n\n.multimedia-hub #infojson,\n.multimedia-hub #infofoto2 {\n  height: 320px !important;\n}\n\n.multimedia-hub .mh-panel-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.multimedia-hub .mh-panel-title,\n.multimedia-hub .mh-analytics-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 38px;\n  padding: 0 12px;\n  border-radius: 12px 12px 0 0;\n  background: linear-gradient(135deg, #0a5a8a, #1178b8);\n  border: 1px solid #0b6ca6;\n  border-bottom: 0;\n  color: #ffffff;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 6px 14px rgba(9, 62, 95, 0.08);\n}\n\n.multimedia-hub .mh-analytics-header-tools {\n  position: relative;\n  justify-content: center;\n  gap: 8px;\n  padding-right: 86px;\n}\n\n.multimedia-hub .mh-analytics-title {\n  display: block;\n  width: 100%;\n  max-width: calc(100% - 96px);\n  text-align: center;\n  color: #ffffff;\n  font-weight: 700;\n  padding: 0 8px;\n}\n\n.multimedia-hub .mh-analytics-actions {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.multimedia-hub .mh-analytics-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.48);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.16);\n  padding: 0;\n  cursor: pointer;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 3px 8px rgba(3, 40, 66, 0.18);\n  transition: transform 0.18s ease, background 0.18s ease, border-color 0.18s ease;\n}\n\n.multimedia-hub .mh-analytics-action-btn:hover {\n  background: rgba(255, 255, 255, 0.24);\n  border-color: rgba(255, 255, 255, 0.72);\n  transform: scale(1.05);\n}\n\n.multimedia-hub .mh-analytics-icon {\n  width: 18px;\n  cursor: pointer;\n  color: #ffffff;\n  filter: brightness(0) invert(1) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.22));\n  opacity: 1;\n}\n\n.multimedia-hub .mh-analytics-action-btn i.mh-analytics-icon {\n  width: auto;\n  font-size: 18px !important;\n  line-height: 1;\n}\n\n.multimedia-hub .mh-info-card,\n.multimedia-hub .mh-analytics-body {\n  border: 1px solid #d0e2f4 !important;\n  border-radius: 0 0 12px 12px;\n  background: linear-gradient(180deg, #ffffff 0%, #f9fcff 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.multimedia-hub .mh-info-card {\n  padding: 10px 14px !important;\n  line-height: 1.35;\n}\n\n.multimedia-hub .mh-analytics-shell .row {\n  align-items: stretch;\n}\n\n.multimedia-hub .mh-analytics-body {\n  border-top: 0 !important;\n  padding: 8px !important;\n}\n\n.multimedia-hub .mh-analytics-shell .col-md-6 {\n  display: flex;\n  flex-direction: column;\n}\n\n.multimedia-hub #infojson .accordion-item {\n  border: 1px solid #dce8f6;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 6px 16px rgba(14, 71, 111, 0.06);\n  margin-bottom: 8px;\n}\n\n.multimedia-hub #infojson .accordion-button {\n  color: #fff !important;\n  border: 0;\n  box-shadow: none !important;\n  font-weight: 700;\n  padding: 8px 10px;\n}\n\n.multimedia-hub #infojson .accordion-button:not(.collapsed) {\n  color: #fff !important;\n}\n\n.multimedia-hub #infojson .accordion-body {\n  padding: 8px 10px;\n  background: #f8fbff;\n}\n\n.multimedia-hub #infojson ul,\n.multimedia-hub #infofoto2 ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.multimedia-hub .attribute_class {\n  margin-bottom: 8px;\n  border: 1px solid #deebf7;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.multimedia-hub .attribute_class .container_span_iconName {\n  display: block;\n  padding: 6px 10px;\n  color: #fff;\n  font-weight: 700;\n}\n\n.multimedia-hub .attribute_content,\n.multimedia-hub .content_content,\n.multimedia-hub .word_content {\n  display: block;\n  padding: 8px 10px;\n  border-top: 1px solid #edf3fa;\n  color: #183d59;\n  font-weight: 600;\n  background: #fff;\n}\n\n.multimedia-hub .content_content,\n.multimedia-hub .word_content {\n  cursor: pointer;\n}\n\n.multimedia-hub .content_content:hover,\n.multimedia-hub .word_content:hover {\n  background: #eef7ff;\n}\n\n.multimedia-hub .object-box,\n.multimedia-hub .object-box2,\n.multimedia-hub .object-box3 {\n  border-radius: 10px;\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.25), 0 8px 20px rgba(12, 92, 144, 0.18);\n}\n\n.multimedia-hub .mh-status-banner {\n  margin-top: 8px;\n  border-radius: 10px;\n  padding: 8px 12px;\n  color: #fff;\n  text-align: center;\n  font-weight: 700;\n  box-shadow: 0 10px 22px rgba(23, 52, 76, 0.14);\n}\n\n.multimedia-hub .mh-status-banner.is-success {\n  background: linear-gradient(135deg, #118a3f, #27b35d);\n}\n\n.multimedia-hub .mh-status-banner.is-danger {\n  background: linear-gradient(135deg, #c62828, #eb5757);\n}\n\n.multimedia-hub .thumbs .thumb.selected,\n.multimedia-hub .thumbs .thumb:hover {\n  border-color: #1283c2;\n}\n\n.multimedia-hub-actions-card {\n  border: 1px solid #dbe8f5;\n  border-radius: 12px;\n  padding: 14px;\n  background: #fff;\n}\n\n.multimedia-hub-actions-card h6 {\n  color: #1a4d75;\n  font-weight: 700;\n  text-align: center;\n}\n\n.multimedia-hub-actions-card p {\n  color: #6a8091;\n  text-align: center;\n}\n\n.multimedia-hub-actions-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.multimedia-hub-actions-col {\n  flex: 1 1 320px;\n  min-width: 280px;\n}\n\n.multimedia-hub-action-icon {\n  width: 72px;\n  height: 72px;\n  margin: 2px auto 10px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0f6ea8;\n  background: linear-gradient(135deg, #eaf5ff, #dff0ff);\n  border: 1px solid #c8e2f8;\n}\n\n.multimedia-hub-action-icon i {\n  font-size: 2rem;\n}\n\n.multimedia-hub-action-btn {\n  width: 100%;\n  justify-content: center;\n  min-height: 42px;\n}\n\n.mh-skeleton-wrap {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 12px;\n}\n\n.mh-skeleton-media,\n.mh-skeleton-panel {\n  border-radius: 12px;\n  border: 1px solid #dbe8f6;\n  background: linear-gradient(110deg, #eef5fc 8%, #f7fbff 18%, #eef5fc 33%);\n  background-size: 200% 100%;\n  animation: mh-shimmer 1.3s linear infinite;\n}\n\n.mh-skeleton-media {\n  min-height: 390px;\n}\n\n.mh-skeleton-panel {\n  min-height: 390px;\n}\n\n.mh-empty-media {\n  min-height: 390px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 12px;\n  background: radial-gradient(circle at top, #183952 0%, #0e2234 46%, #081521 100%);\n  color: #d8eeff;\n  border: 1px solid #224e70;\n}\n\n.mh-empty-media i {\n  font-size: 2.2rem;\n  margin-bottom: 10px;\n  color: #5dc3ff;\n}\n\n.mh-empty-media h4 {\n  margin: 0;\n  font-weight: 700;\n}\n\n.mh-empty-media p {\n  margin-top: 8px;\n  max-width: 320px;\n  color: #a8d6f6;\n}\n\n@keyframes mh-shimmer {\n  to {\n    background-position-x: -200%;\n  }\n}\n\n@keyframes mh-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .multimedia-hub {\n    padding: 8px;\n    border-radius: 10px;\n    margin: 0;\n    width: 100%;\n  }\n\n  .multimedia-hub-header {\n    gap: 8px;\n    margin-bottom: 10px;\n  }\n\n  .multimedia-hub-title {\n    font-size: 1rem;\n  }\n\n  .multimedia-hub-subtitle {\n    font-size: 0.8rem;\n    line-height: 1.2;\n  }\n\n  .multimedia-hub-chip {\n    font-size: 0.72rem;\n    padding: 4px 8px;\n    max-width: 42%;\n    line-height: 1.2;\n  }\n\n  .multimedia-hub-tabs {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n    width: 100%;\n  }\n\n  .mh-tab {\n    width: 100%;\n    justify-content: center;\n    font-size: 0.84rem;\n    padding: 8px 10px;\n    min-height: 40px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .multimedia-hub-links {\n    margin: 10px 0 12px;\n    font-size: 0.9rem;\n    line-height: 1.35;\n  }\n\n  .multimedia-hub-content {\n    padding: 8px;\n    border-radius: 10px;\n  }\n\n  .multimedia-hub-content .row {\n    --bs-gutter-x: 8px;\n    --bs-gutter-y: 8px;\n  }\n\n  .multimedia-hub-actions-col {\n    flex-basis: 100%;\n    min-width: 0;\n  }\n\n  .multimedia-hub .en-vivo-panel {\n    padding: 6px;\n  }\n\n  .multimedia-hub .en-vivo-layout {\n    gap: 8px;\n  }\n\n  .multimedia-hub .en-vivo-card,\n  .multimedia-hub .en-vivo-tracking {\n    padding: 10px;\n    border-radius: 10px;\n  }\n\n  .multimedia-hub .en-vivo-preview {\n    margin-bottom: 8px;\n  }\n\n  .multimedia-hub #prueba {\n    padding: 6px;\n    margin-bottom: 6px;\n  }\n\n  .multimedia-hub #infofoto {\n    margin-bottom: 6px;\n  }\n\n  .mh-skeleton-wrap {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-skeleton-media,\n  .mh-skeleton-panel,\n  .mh-empty-media {\n    min-height: 240px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
